/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, Fragment, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import Helpers from '@Apis/helpers';
import AnalyticsActions from '@Actions/application/analyticsActions';
import MetricWithMiniGraph from '@Components/Home/HomeTabs/Widgets/MetricWithMiniGraph';
import H3DateSelector from '@Uilib/h3DateSelector';
import MetricWithStatusSplit from '@Components/Home/HomeTabs/Widgets/MetricWithStatusSplit';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import MetricPieChart from '@Components/Home/HomeTabs/Widgets/MetricPieChart';
import ActivityCalendar from '@Components/Home/HomeTabs/Widgets/ActivityCalendar';
import MetricStackedBarChart from '@Components/Home/HomeTabs/Widgets/MetricStackedBarChart';
import MetricWithAmountSplit from '@Components/Home/HomeTabs/Widgets/MetricWithAmountSplit';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';
import './style.scss';

/**
 *
 */
function PurchaseDashboard({
  user, history, getAnalyticsData, analytics,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedInterval, setSelectedInterval] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [isUserReady, setIsUserReady] = useState(false);
  const [call, setCall] = useState(false);

  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'tenant',
      filter_value: Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ),
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'startDate',
      filter_value: dateRangePresetsValues(dateRangePresets.THIS_MONTH)[0],
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: dateRangePresets.THIS_MONTH,
    },
    {
      filter_key: 'endDate',
      filter_value: dateRangePresetsValues(dateRangePresets.THIS_MONTH)[1],
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: dateRangePresets.THIS_MONTH,
    },
  ], []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.PURCHASE_DASHBOARD,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  const pushParamsToUrl = (tenant, start, end, orderDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '?tab=/purchase-dashboard&';
    if (tenant) url += `tenant=${tenant}`;
    if (start) url += `&startDate=${start}`;
    if (end) url += `&endDate=${end}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setStartDate(Number(Helpers.getValueFromUrl('start')) || dayjs().utc().startOf('month').valueOf());
      // setEndDate(Number(Helpers.getValueFromUrl('end')) || dayjs().utc().endOf('month').subtract(1, 'day')
        // .valueOf());
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ));
      // setIsUserReady(true);
      setSelectedFilterView(systemDefaultUserView);
    }
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }

        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setSelectedTenant(tempFilterValues.tenant);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  /**
   *
   */
  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(selectedTenant, startDate, endDate, orderDateSelectedIntervalDateRangeType, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getAnalyticsData('PURCHASE', 'TOTAL_SPEND', {
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
      });
      getAnalyticsData('PURCHASE', 'PURCHASE_BY_STATUS', {
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
      });
      getAnalyticsData('PURCHASE', 'PURCHASE_BY_APPROVAL_STATUS', {
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
      });
      getAnalyticsData('PURCHASE', 'OVERDUE_GRN', {
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
      });
      getAnalyticsData('PURCHASE', 'PR_BY_DEPARTMENT', {
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD'),
        tenantIds: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(','),
      });
    }
  }, [selectedTenant, startDate, endDate, call, orderDateSelectedIntervalDateRangeType]);

  /**
   *
   * @returns {{count: number, list: ({color: string, count: number, label: string, value: number}|{color: string, count: number, label: string, value: number}|{color: string, count: number, label: string, value: number})[], value: number, entity: string}}
   */
  const getStatusSplitData = () => {
    const data = analytics?.PURCHASE?.PURCHASE_BY_STATUS?.data;
    let totalCount = 0;
    let totalValue = 0;
    const received = {
      count: 0,
      value: 0,
      label: 'Received',
      color: 'rgb(34, 197, 94)',
    };
    const notReceived = {
      count: 0,
      value: 0,
      label: 'Pending Receiving',
      color: 'rgb(255, 171, 0)',
    };
    const expired = {
      count: 0,
      value: 0,
      label: 'Expired',
      color: 'rgb(255, 86, 48)',
    };
    const notApproved = {
      count: 0,
      value: 0,
      label: 'Pending Approval',
      color: '#1c7be1',
    };
    for (let i = 0; i < data?.length; i++) {
      if (data[i]?.po_receiving_status === 'NOT_RECEIVED') {
        notReceived.count += Number(data[i]?.not_expired_po_count);
        notReceived.value += Number(data[i]?.receiving_details?.[0]?.pending_value);
        expired.count += Number(data[i]?.expired_po_count);
        expired.value += Number(data[i]?.receiving_details?.[0]?.expired_value);
        totalCount += Number(data[i]?.po_count);
        totalValue += Number(data[i]?.po_value);
      }
      if (data[i]?.po_receiving_status === 'PARTIALLY_RECEIVED') {
        notReceived.count += Number(data[i]?.not_expired_po_count);
        notReceived.value += Number(data[i]?.receiving_details?.[0]?.pending_value);
        received.count += Number(data[i]?.not_expired_po_count);
        received.value += Number(data[i]?.receiving_details?.[0]?.received_value);
        expired.count += Number(data[i]?.expired_po_count);
        expired.value += Number(data[i]?.receiving_details?.[0]?.expired_value);
        totalCount += Number(data[i]?.po_count);
        totalValue += Number(data[i]?.po_value);
      }
      if (data[i]?.po_receiving_status === 'RECEIVED') {
        received.count += Number(data[i]?.not_expired_po_count);
        received.count += Number(data[i]?.expired_po_count);
        received.value += Math.min(Number(data[i]?.po_value), Number(data[i]?.receiving_details?.[0]?.received_value));
        totalCount += Number(data[i]?.po_count);
        totalValue += Number(data[i]?.po_value);
      }
      if (data[i]?.po_receiving_status === 'RECEIVED_MORE') {
        received.count += Number(data[i]?.not_expired_po_count);
        received.value += Math.min(Number(data[i]?.po_value), Number(data[i]?.receiving_details?.[0]?.received_value));
        totalCount += Number(data[i]?.po_count);
        totalValue += Number(data[i]?.po_value);
      }
      if (data[i]?.po_receiving_status === 'SENT_FOR_APPROVAL') {
        notApproved.count += Number(data[i]?.po_count);
        notApproved.value += data[i]?.po_value;
        totalCount += Number(data[i]?.po_count);
        totalValue += Number(data[i]?.po_value);
      }
    }
    return {
      count: totalCount,
      value: totalValue,
      entity: 'Issued Purchase Orders',
      list: [
        {
          ...received,
          url: `/purchase/purchase-orders?page=1&limit=10&tenant=${selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(',')}&po_receiving_status=RECEIVED,PARTIALLY_RECEIVED,RECEIVED_MORE&startDate=${startDate}&endDate=${endDate}&status=ISSUED`,
        }, {
          ...notReceived,
          url: `/purchase/purchase-orders?page=1&limit=10&tenant=${selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(',')}&po_receiving_status=NOT_RECEIVED,PARTIALLY_RECEIVED&startDate=${startDate}&endDate=${endDate}&status=ISSUED&expiry_start_date=${dayjs().startOf('day')?.valueOf()}&expiry_end_date=${dayjs().add('100', 'years')?.valueOf()}`,
        }, {
          ...expired,
          url: `/purchase/purchase-orders?page=1&limit=10&tenant=${selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(',')}&po_receiving_status=NOT_RECEIVED,PARTIALLY_RECEIVED&startDate=${startDate}&endDate=${endDate}&exp_time_range=Expired&status=ISSUED`,
        },
        {
          ...notApproved,
          url: `/purchase/purchase-orders?page=1&limit=10&tenant=${selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(',')}&startDate=${startDate}&endDate=${endDate}&status=SENT_FOR_APPROVAL`,
        },
      ].map((item) => ({
        ...item,
        url: Helpers.appendSystemDefaultFilterIdInURL(item?.url),
      })),
    };
  };

  const getApprovalStatusSplitData = () => {
    const data = analytics?.PURCHASE?.PURCHASE_BY_APPROVAL_STATUS?.data;
    const statusData = [];
    let totalCount = 0;
    let totalValue = 0;
    for (let i = 0; i < data?.length; i++) {
      totalCount += Number(data[i]?.po_count);
      totalValue += Number(data[i]?.po_value);
      statusData.push({
        count: Number(data[i]?.po_count),
        value: Number(data[i]?.po_value),
        type: data[i]?.status,
        color: Helpers.getStatusColor(data[i]?.status).color,
        url: Helpers.appendSystemDefaultFilterIdInURL(`/purchase/purchase-orders?page=1&limit=10&tenant=${selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)?.join(',')}&startDate=${startDate}&endDate=${endDate}&status=${data[i]?.status}`),
      });
    }
    return {
      count: totalCount,
      value: totalValue,
      entity: 'Created Purchase Orders',
      list: statusData,
    };
  };

  const getPaymentDueData = () => {
    const data = analytics?.PURCHASE?.OVERDUE_GRN?.data;
    const totalCount = Number(data?.[0]?.today_due_grn_count) + Number(data?.[0]?.overdue_grn_count) + Number(data?.[0]?.future_due_grn_count);
    const totalValue = Number(data?.[0]?.today_due_amount) + Number(data?.[0]?.overdue_amount) + Number(data?.[0]?.future_due_amount);
    return {
      overdueCount: Number(data?.[0]?.overdue_grn_count),
      overdueValue: Number(data?.[0]?.overdue_amount),
      overdueColor: 'rgb(245,210,47)',
      currentCount: Number(data?.[0]?.future_due_grn_count) + Number(data?.[0]?.today_due_grn_count),
      currentValue: Number(data?.[0]?.future_due_amount) + Number(data?.[0]?.today_due_amount),
      currentColor: 'rgb(34, 197, 94)',
      count: totalCount,
      value: totalValue,
      overdueList: {
        '1-15_days': {
          count: Number(data?.[0]?.overdue_1_15_count),
          amount: Number(data?.[0]?.overdue_1_15_amount),
          fromDate: dayjs().subtract(14, 'day').format('YYYY-MM-DD'),
          toDate: dayjs().format('YYYY-MM-DD'),
        },
        '16-30_days': {
          count: Number(data?.[0]?.overdue_16_30_count),
          amount: Number(data?.[0]?.overdue_16_30_amount),
          fromDate: dayjs().subtract(29, 'day').format('YYYY-MM-DD'),
          toDate: dayjs().subtract(15, 'day').format('YYYY-MM-DD'),
        },
        '31-45_days': {
          count: Number(data?.[0]?.overdue_31_45_count),
          amount: Number(data?.[0]?.overdue_31_45_amount),
          fromDate: dayjs().subtract(44, 'day').format('YYYY-MM-DD'),
          toDate: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
        },
        above_45_days: {
          count: Number(data?.[0]?.overdue_45_plus_count),
          amount: Number(data?.[0]?.overdue_45_plus_amount),
          fromDate: dayjs().subtract(100, 'year').format('YYYY-MM-DD'),
          toDate: dayjs().subtract(45, 'day').format('YYYY-MM-DD'),
        },
      },
      entity: 'Total Payable',
    };
  };

  const getPrDepartmentSplitData = () => {
    const data = analytics?.PURCHASE?.PR_BY_DEPARTMENT?.data;
    const prData = [];
    for (let i = 0; i < data?.length; i++) {
      for (let j = 0; j < data[i]?.status_split?.length; j++) {
        prData.push({
          department: data[i]?.department_name?.toProperCase(),
          color: Helpers.getStatusColor(data?.[i]?.status_split?.[j]?.status).color,
          value: parseInt(data?.[i]?.status_split?.[j]?.count),
          status: data?.[i]?.status_split?.[j]?.status?.replaceAll('_', ' ')?.toProperCase(),
          department_id: data?.[i]?.department_id,
        });
      }
    }
    return prData;
  };

  /**
   *
   * @returns {number}
   */
  const getPrChartTitle = () => {
    let total = 0;
    const prs = analytics?.PURCHASE?.PR_BY_DEPARTMENT?.data;
    for (let i = 0; i < prs?.length; i++) {
      total += parseInt(prs[i]?.pr_count);
    }
    return total;
  };

  return (
    <Fragment>
      <div className="dashboard-filters doc-list__wrapper doc-list__tab-content">
        <div className="flex-display" style={{ gap: '10px' }}>
          <UserSavedFilterViewSelector
            selectedFilterView={selectedFilterView}
            onChangeTab={(currentSelectedView) => {
              setSelectedFilterView(() => {
                const currentSelectedViewFilters = currentSelectedView.filters;

                const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                let _orderStartDate = '';
                let _orderEndDate = '';

                if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                  // No action needed for empty or custom date range type
                } else {
                  const date = dateRangePresetsValues(_orderDateRangeType);
                  const [start, end] = date;

                  _orderStartDate = start;
                  _orderEndDate = end;
                  filterValue.startDate = _orderStartDate;
                  filterValue.endDate = _orderEndDate;
                }

                filterValue.orderDateRangeType = _orderDateRangeType;

                const tempFilterValues = filterValue;
                setCurrentPage(1);
                setSelectedTenant(tempFilterValues.tenant);
                setStartDate(tempFilterValues.startDate);
                setEndDate(tempFilterValues.endDate);
                setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);

                return currentSelectedView;
              });
            }}
            currentlyAppliedFilters={currentlyAppliedFilters}
            entityName={entityNameEnum.PURCHASE_DASHBOARD}
            setSavedFilterViews={(value) => setSavedFilterViews(value)}
            setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
            setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
            callback={() => {
              if (!isUserReadyInitial) setIsUserReadyInitial(true);
            }}
            systemDefaultUserView={systemDefaultUserView}
          />
          <div className="flex-display">
            <TenantSelector
              selectedTenant={selectedTenant}
              showSearch
              showAll={false}
              noDropdownAlign
              isMultiple
              onChange={(value) => {
                setSelectedTenant(value);
              }}
              placeholder="Select Business Unit"
              inputClassName="orgInputContainer"
              hideTitle
              includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)}
            />
            <H3DateSelector
              selectedInterval={orderDateSelectedIntervalDateRangeType}
              startDate={startDate}
              endDate={endDate}
              // onDateChange={(date) => {
              //   const getFormattedDate = (d) => (dayjs(new Date(d).toISOString()?.split('T')?.[0]));
              //   setStartDate(date[0]?.valueOf());
              //   setEndDate(date[1]?.valueOf());
              //   setSelectedInterval('customize');
              //   pushParamsToUrl(selectedTenant, getFormattedDate(date[0])?.valueOf(), getFormattedDate(date[1])?.valueOf());
              // }}
              onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                setCurrentPage(1);
                setOrderDateSelectedIntervalDateRangeType(dateRangeType);
              }}
            />
          </div>
        </div>
      </div>
      <div className="ant-row" style={{ marginTop: '20px' }}>
        <div className="ant-col-md-8 ant-col-xs-24">
          <MetricWithMiniGraph
            days={dayjs(endDate).diff(startDate, 'days') + 1}
            currentData={analytics?.PURCHASE?.TOTAL_SPEND?.data?.[0]?.curr_po_value}
            previousData={analytics?.PURCHASE?.TOTAL_SPEND?.data?.[0]?.prev_po_value}
            seriesData={analytics?.PURCHASE?.TOTAL_SPEND?.data?.[0]?.day_wise_breakup?.map((item) => ({
              date: item?.po_data,
              value: item?.po_value,
              count: item?.po_count,
            }))}
            loading={analytics?.PURCHASE?.TOTAL_SPEND?.loading}

          />
        </div>
        <div className="ant-col-md-8 ant-col-xs-24">
          <MetricWithAmountSplit
            data={getPaymentDueData()}
            loading={analytics?.PURCHASE?.OVERDUE_GRN?.loading}
            selectedTenant={selectedTenant}
            redirectOverDue
          />
        </div>
        <div className="ant-col-md-8 ant-col-xs-24">
          {/* <MetricWithStatusSplit data={getPaymentDueData()} loading={analytics?.PURCHASE?.OVERDUE_GRN?.loading} /> */}
          {/* <MetricPieChart data={getApprovalStatusSplitData()} loading={analytics?.PURCHASE?.PURCHASE_BY_APPROVAL_STATUS?.loading} /> */}
          <ActivityCalendar data={analytics?.PURCHASE?.PURCHASE_SCHEDULE} selectedTenant={selectedTenant} />
        </div>
      </div>
      <div className="ant-row" style={{ marginTop: '15px', marginBottom: '15px' }}>
        <div className="ant-col-md-12 ant-col-xs-24">
          <MetricWithStatusSplit data={getStatusSplitData()} loading={analytics?.PURCHASE?.PURCHASE_BY_STATUS?.loading} showOrderValue />
        </div>
        <div className="ant-col-md-12 ant-col-xs-24">
          <MetricStackedBarChart
            data={getPrDepartmentSplitData()}
            loading={analytics?.PURCHASE?.PR_BY_DEPARTMENT?.loading}
            title={`${getPrChartTitle()} Material Requests`}
            selectedTenant={selectedTenant}
            fromDate={startDate}
            toDate={endDate}
          />
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({ UserReducers, AnalyticsReducers }) => ({
  user: UserReducers.user,
  analytics: AnalyticsReducers.analytics,
});

const mapDispatchToProps = (dispatch) => ({
  getAnalyticsData: (dataType, name, params) => dispatch(AnalyticsActions.getAnalyticsData(dataType, name, params)),
});

PurchaseDashboard.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
  analytics: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseDashboard));
